export default "__VITE_ASSET__BGETsmis__"